import {connect} from 'react-redux';
import {ContentFooter as Component} from './ContentFooter';
import {createSelector} from 'reselect';
import {
  setNoteBookSection,
  showModal,
  setModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    nextSection: getNextSection(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toNextSection: (section) => {
      dispatch(setNoteBookSection(section));
    },
    showModal: (section) => {
      dispatch(showModal(section));
    },
    setModal: (section) => {
      dispatch(setModal(section));
    },
  };
}

export const ContentFooter = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);

// Reselect Methods
const getAllSections = ({notebook}) => notebook.sections;

const getNextSection = createSelector([getAllSections], (allSections) => {
  const currentSection = allSections.find(
    (section) => section.current === true
  );
  const nextSection = allSections.find(
    (section) => section.number === currentSection.number + 1
  );
  return nextSection;
});
